// Storefront-only restriction; subscription contracts remain managed by the app.
(() => {
  const allowedPlanId = '4681597153'; // 毎月10日〜15日にお届け
  function restrictDeliveryWindow() {
    document.querySelectorAll('.huckleberry-subscription-widget-container').forEach((widget) => {
      const options = [...widget.querySelectorAll('input[name="planOption"]')];
      const allowed = options.find((option) => option.value === allowedPlanId);
      if (!allowed) return;

      options.forEach((option) => {
        option.disabled = option !== allowed;
      });
      // Use the app's event handler so its state, prices and hidden form inputs agree.
      if (!allowed.checked) allowed.click();
    });
  }

  restrictDeliveryWindow();
  // The subscription app loads asynchronously and can replace the widget DOM.
  new MutationObserver(restrictDeliveryWindow).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
